import _ from 'lodash'
import qs from 'qs'

/**
 * 编译环境
 */
export const Env: 'dev' | 'release' = process.env['VUE_APP_ENV'] as any

/**
 * api请求base地址
 */
export const API_BASE_URL: string = process.env['VUE_APP_API_BASE_URL']


export const IsRelease = Env === 'release'

const searchObj = qs.parse(location.search, {
    ignoreQueryPrefix: true,
})

export const InDebug = (!!localStorage.getItem('jj_debug')) || (_.has(searchObj, 'jj_debug'))

if (InDebug) {
    console.log('%cwarning: 在调试模式下!!!', 'color: var(--color-danger); font-size: 80px')
}
